export const MEGABYTE_IN_BYTES = 1000000;